/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Scroll_LabelInputs */

const es_home_hero_scroll_label = /** @type {(inputs: Home_Hero_Scroll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al contenido`)
};

const en_home_hero_scroll_label = /** @type {(inputs: Home_Hero_Scroll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll to content`)
};

/**
* | output |
* | --- |
* | "Scroll to content" |
*
* @param {Home_Hero_Scroll_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_scroll_label = /** @type {((inputs?: Home_Hero_Scroll_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Scroll_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_scroll_label(inputs)
	return en_home_hero_scroll_label(inputs)
});
export { home_hero_scroll_label as "home.hero.scroll_label" }